import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  register () {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/across/register',
        {},
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDescriptions () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/across/descriptions',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getInventory () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/inventory',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDeliveryList () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/delivery/list',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/across/delivery/shipping-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDeliveryInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/delivery/delivery-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerAcrossDelivery (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/delivery/direct',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDirectDeliveryDetail (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/delivery/direct',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateDirectDelivery (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/across/delivery/direct',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteDirectDelivery (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/across/delivery/direct',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateAmazonInventory (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/delivery/amazon-inventory',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerAmazonDelivery (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/delivery/amazon',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAmazonDeliveryDetail (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/delivery/amazon',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingList (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping-list',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getStockByExpDate (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping/get-stock-by-exp-date',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingStockInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/get-stock-info',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAmazonShippingStockInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/amazon/get-stock-info',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode === '4991' || response.data.header.resultCode === '4992') {
            reject(response.data)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerAmazonShipping (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/amazon',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAmazonShippingDetail (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping/amazon',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingMultichannelInfo () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping/multichannel/from-info',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/across/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  setDefaultShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/multichannel/from-info-default',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteShippingMultichannelInfo (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/across/shipping/multichannel/from-info',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingMultiDetail (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/across/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/across/shipping/multichannel',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getMaintenanceMode () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/maintenance',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  exportShippingCost (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/expense/shipping-cost/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  exportOtherCost (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/expense/other-cost/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  getIdentifiers (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/identifiers',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadProductCSV (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/inventory/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  getMonths (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/inventory/months',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadInventoryEndOfMonthCSV (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/inventory/months/export-csv',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  changeBarcode (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/inventory/change-barcode',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registerShippingSc (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/sc',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getShippingSc (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/across/shipping/sc',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingSc (params) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/across/shipping/sc',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteShippingSc (params) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'Warehouse/across/shipping/sc',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadDirectDeliveryProductsTemplate (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/delivery/direct/product-available/template',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  downloadProductsCsvTemplate (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/products-csv-template',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  downloadMultichanelProductsCsvTemplate (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Warehouse/across/shipping/multichannel/template',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },
  bulkRegisterShippingMultichannel (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/across/shipping/multichannel/bulk-register',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/warehouseacrossservice.js